import {ModuleWithProviders} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {OperationTheaterComponent} from './operation-theater.component';

const routes: Routes = [
    {
        path: 'ot', component: OperationTheaterComponent,
        children: [
            {path: 'otschedule', loadChildren: 'app/operation-theater/ot-schedule/ot-schedule.module#OtScheduleModule'},
            {path: 'otschedule/:requestfrom/:patientid/:opsid', loadChildren: 'app/operation-theater/ot-schedule/ot-schedule.module#OtScheduleModule'},
            {path: 'otschedulelist', loadChildren: 'app/operation-theater/otshedule-list/otshedule-list.module#OtsheduleListModule'},
            {path: 'otdetails', loadChildren: 'app/operation-theater/ot-details/ot-details.module#OtDetailsModule'},
            {path: 'otdetails/:odsid', loadChildren: './ot-details/ot-details.module#OtDetailsModule'},
            {path: 'otdetailslist', loadChildren: 'app/operation-theater/otdetails-list/otdetails-list.module#OtdetailsListModule'},
            {path: 'otrequest', loadChildren: 'app/operation-theater/ot-request/ot-request.module#OtRequestModule'},
        ]
    }
];


export const routing: ModuleWithProviders = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/operation-theater/operation-theater.routing.ts